const PARTIAL_CONTENT = 206 as const;
const UNAUTHORIZED = 401 as const;
const FORBIDDEN = 403 as const;
const INTERNAL_SERVER_ERROR = 500 as const;

export const HTTPS_CODE = {
  PARTIAL_CONTENT,
  UNAUTHORIZED,
  FORBIDDEN,
  INTERNAL_SERVER_ERROR,
};
